<template>
  <v-card>
    <v-card-text>
      <v-layout row>
        <v-flex lg12>
          <v-layout row>
            <v-flex xs12 class="py-0">
              <div class="ma-0 text-xs-right">
                <v-btn class="mr-0 mb-0"
                       color="default"
                       round small
                       @click.stop="clearFilters()">
                  {{ translation('filters.btn-clear.filters') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 lg3 d-flex>
              <!-- filter dealer component -->
              <filter-select
                v-if="renderFilters"
                filter-id = "brand_name"
                filter-key = "filterBrand"
                filter-name = "filter.name.brand"
                @update-filters="updateFilters">
              </filter-select>
            </v-flex>
            <v-flex xs12 sm6 lg3 d-flex>
              <!-- filter dealer component -->
              <filter-select
                v-if="renderFilters"
                filter-id = "dealer_name"
                filter-key = "filterDealer"
                filter-name = "filter.name.dealer"
                @update-filters="updateFilters">
              </filter-select>
            </v-flex>
            <v-flex xs12 sm6 lg3 d-flex>
              <!-- filter dealer component -->
              <filter-select
                v-if="renderFilters"
                filter-id = "is_salesman"
                filter-key = "null"
                filter-name = "filter.name.is-salesman"
                @update-filters="updateFilters">
              </filter-select>
            </v-flex>
            <v-flex xs12 sm6 lg3 d-flex>
              <!-- filter dealer component -->
              <filter-select
                v-if="renderFilters"
                filter-id = "is_salesmanager"
                filter-key = "null"
                filter-name = "filter.name.is-salesmanager"
                @update-filters="updateFilters">
              </filter-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 class="py-0">
              <div class="ma-0 text-xs-right">
                <v-btn class="mr-0"
                       color="accent"
                       round
                       @click.stop="applyFilters()">
                  {{ translation('filters.btn-apply.filters') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import filter components
import FilterSelect from '@/components/filters/FilterSelect'

const initFilters = [
  {
    outputId: 'brand_name',
    queryKey: 'filterBrand',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'dealer_name',
    queryKey: 'filterDealer',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 10000
    }
  },
  {
    outputId: 'is_salesman',
    queryKey: null,
    disabled: false,
    type: 'select',
    returnObject: true,
    data: [
      { name: 'filter.select.defined-all', value: -1 },
      { name: 'filter.select.defined-yes', value: 1 },
      { name: 'filter.select.defined-no', value: 0 }
    ],
    default: { name: 'filter.select.defined-all', value: -1 }
  },
  {
    outputId: 'is_salesmanager',
    queryKey: null,
    disabled: false,
    type: 'select',
    returnObject: true,
    data: [
      { name: 'filter.select.defined-all', value: -1 },
      { name: 'filter.select.defined-yes', value: 1 },
      { name: 'filter.select.defined-no', value: 0 }
    ],
    default: { name: 'filter.select.defined-all', value: -1 }
  }
]

export default {
  name: 'DashboardLeadsFilters',
  components: {
    FilterSelect
  },
  props: {
    dashboardId: { type: String, required: true }
  },
  data () {
    return {
      renderFilters: false
    }
  },
  computed: {
    ...mapGetters(['selectedFiltersGen', 'translation'])
  },
  created () {
    // set dashboard data with received props
    this.setGeneric(true)
    this.$log.info(`-${this.dashboardId} dashboard filters component created-`)
    this.$log.info('Initializing filters', initFilters)
    initFilters.forEach(filter => {
      if (!filter.queryKey) {
        filter.data.forEach(data => {
          data.name = this.translation(data.name)
        })
      }
      return filter
    })
    this.setInitialSelectedFilters(initFilters)
    this.resetFilters()
    // fetch filters data
    this.updateFilters()
    this.renderFilters = true
  },
  methods: {
    ...mapMutations({
      setInitialSelectedFilters: 'GEN_SET_INITIAL_SELECTED_FILTERS',
      // disabled filters mutations
      setItemStatus: 'GEN_SET_ITEM_FILTER_STATUS',
      // set dashboard as generic
      setGeneric: 'GEN_SET_GENERIC'
    }),
    ...mapActions([
      // fetch filters actions
      'fetchDataGen'
    ]),
    updateFilters () {
      const requestPayloadData = {
        filters: this.selectedFiltersGen,
        dashboardId: this.dashboardId
      }
      // fetch filters
      initFilters.forEach(val => {
        if (val.queryKey) {
          this.fetchDataGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey, pagination: val.pagination })
        }
      })
    },
    applyFilters () {
      this.$emit('apply-filters')
    },
    resetFilters () {
      this.$store.commit('GEN_RESET_FILTERS', initFilters)
    },
    clearFilters () {
      // reset filters to init state
      this.resetFilters()
      // set disabled states to false
      initFilters.forEach(val => {
        this.setItemStatus(val.outputId, true)
      })
      this.updateFilters()
      // emit event for fetching data with selected filters
      this.$emit('clear-filters')
    }
  },
  beforeDestroy () {
    this.$log.info(`-${this.dashboardId} filters before destroyed-`)
    this.resetFilters()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
